export { default } from './arrow-top-right'
